import { getPagePath, trans } from '@spotahome/soyuz/client';

import SupportCenter from '../SupportCenter';

import FooterSimplifiedBlockTitle from './components/FooterSimplifiedBlockTitle';
import FooterSimplifiedLink from './components/FooterSimplifiedLink';

const SupportFooter = () => (
  <div>
    <FooterSimplifiedBlockTitle text={trans('footer.label.support')} />
    <SupportCenter backgroundColor="white" photo="blueShort" />
    <FooterSimplifiedLink
      key="footer.item.contact_support"
      href={getPagePath('contact-us')}
    >
      {trans('footer.item.contact_support')}
    </FooterSimplifiedLink>
  </div>
);

export default SupportFooter;
